export default {
  computed: {
    validationNames() {
      return [
        'required',
        'requiredIf',
        'requiredUnless',
        'minLength',
        'decimal',
        'minValue',
        'maxValue',
        'between',
        'alpha',
        'alphaNum',
        'numeric',
        'integer',
        'decimal',
        'email',
        'ipAddress',
        'macAddress',
        'sameAs',
        'url',
        'not',
        'pesel',
        'momentMax',
        'momentMin',
        'momentBetween',
        'postalCode',
        'landRegister',
        'krs',
        'acceptance',
        'mbankPasswordComplexity',
        'mbankPasswordLength',
        'mbankChecked',
      ]
    },
  },
  methods: {
    errMessage(kind, params) {
      let val
      let valTwo
      switch (kind) {
        case 'required':
        case 'requiredIf':
        case 'requiredUnless':
          return 'jest wymagane'
          break
        case 'minLength':
          return 'jest zbyt krótkie'
          break
        case 'maxLength':
          return 'jest zbyt krótkie'
          break
        case 'minValue':
          val = params.min
          if (val instanceof Date) {
            val = moment(val).format('DD.MM.YYYY')
            return `data musi być późniejsza lub równa ${val}`
          } else {
            return `musi być większe lub równe ${val}`
          }
          break
        case 'maxValue':
          val = params.max
          if (val instanceof Date) {
            val = moment(val).format('DD.MM.YYYY')
            return `data musi być wcześniejsza lub równa ${val}`
          } else {
            return `musi być mniejsze lub równe ${val}`
          }
          break
        case 'between':
          val = params.min
          if (val instanceof Date) {
            val = moment(val).format('DD.MM.YYYY')
          }
          valTwo = params.max
          if (valTwo instanceof Date) {
            valTwo = moment(valTwo).format('DD.MM.YYYY')
          }
          return `musi zawierać się pomiędzy ${val} a ${valTwo}`
          break
        case 'alpha':
          return 'może zawierać tylko litery'
          break
        case 'alphaNum':
          return 'może zawierać tylko cyfry i litery'
          break
        case 'numeric':
          return 'może zawierać tylko cyfry'
          break
        case 'integer':
          return 'musi być liczbą całkowitą'
          break
        case 'decimal':
          return 'musi być liczbą'
          break
        case 'email':
          return 'niepoprawny format e-mail'
          break
        case 'ipAddress':
          return 'niepoprawny format adresu IP'
          break
        case 'macAddress':
          return 'niepoprawny format adresu MAC'
          break
        case 'sameAs':
          return 'musi być takie samo, jak ...'
          break
        case 'url':
          return 'niepoprawny format adresu URL'
          break
        case 'not':
          return 'not'
          break
        case 'pesel':
          return 'niepoprawny PESEL'
          break
        case 'momentMax':
          return `data musi być wcześniejsza lub równa ${moment(params.max).format('DD.MM.YYYY')}`
          break
        case 'momentMin':
          return `data musi być późniejsza lub równa ${moment(params.min).format('DD.MM.YYYY')}`
          break
        case 'momentBetween':
          return `data musi być zawierać się między ${moment(params.min).format(
            'DD.MM.YYYY',
          )} a  ${moment(params.max).format('DD.MM.YYYY')}`
          break
        case 'postalCode':
          return 'niepoprawny format (XX-XXX)'
          break
        case 'landRegister':
          return 'niepoprawny numer księgi wieczystej (XXXX/XXXXXXXX/X)'
          break
        case 'krs':
          return 'niepoprawny numer KRS (XXXXXXXXXX)'
          break
        case 'acceptance':
          return 'musi zostać zaznaczone'
          break
        case 'mbankPasswordComplexity':
          return 'Hasło musi zawierać małe i wielkie litery oraz cyfry lub znaki specjalne'
          break
        case 'mbankPasswordLength':
          return 'Hasło musi mieć 12 znaków'
          break
        case 'mbankChecked':
          return 'Powinno być zaznaczone'
          break
      }
    },
    validateForm() {
      this.errors = {}
      if (this.submitted && this.$v && this.$v.$invalid) {
        const mainItemName = this.validatedItemKey || 'item'

        const attributesValidated = _.filter(
          _.keys(this.$v[mainItemName]),
          k => k.indexOf('$') == -1,
        )

        _.each(attributesValidated, attr => {
          if (this.$v[mainItemName][attr].$invalid) {
            let message = []
            // if attr
            _.each(this.validationNames, validation => {
              if (this.$v[mainItemName][attr][validation] == false) {
                message.push(
                  this.errMessage(validation, this.$v[mainItemName][attr].$params[validation]),
                )
              }
            })
            if (message.length == 0) {
              const nestedAttributesValidated = _.filter(
                _.keys(this.$v[mainItemName][attr]),
                k => k.indexOf('$') == -1,
              )
              _.each(nestedAttributesValidated, nestedAttr => {
                message = []
                if (this.$v[mainItemName][attr][nestedAttr].$invalid) {
                  _.each(this.validationNames, validation => {
                    if (this.$v[mainItemName][attr][nestedAttr][validation] == false) {
                      message.push(
                        this.errMessage(
                          validation,
                          this.$v[mainItemName][attr][nestedAttr].$params[validation],
                        ),
                      )
                    }
                  })
                }
                if (message.length > 0) {
                  if (!this.errors[attr]) {
                    this.errors[attr] = {}
                  }
                  this.errors[attr][nestedAttr] = _.uniq(message).join('; ')
                }
              })
            } else {
              this.errors[attr] = _.uniq(message).join('; ')
            }
          }
        })
      }
    },
  },
}
